<script>
    import {links, navigate} from "svelte-routing";
    import ComponentItemsList from "./ComponentItemsList.svelte";
    import MenuItemSettings from "./MenuItemSettings.svelte";
    import {getContext} from "svelte";

    const { open } = getContext('simple-modal');

    export let id;
    export let model_root;
    export let application_root;

    $ : menuItem = loadMenuItem(id);
    $ : childItems = loadChildItems(id);

    function loadMenuItem(id) {
        return fetch(model_root + 'shared/menu/load_menu_item.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function loadChildItems(id) {
        return fetch(model_root + 'shared/menu/load_child_items.php?mid=' + id, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function openMenuItemSettings(settings) {
        open(MenuItemSettings, {
            model_root: model_root,
            mid: id,
            settings: settings
        }, {}, {
            onClosed: () => {
                location.reload();
            }
        });
    }
</script>

<div use:links>
    <h4 class="text-muted">Seiteninhalte</h4>
    {#await menuItem}
        <p class="alert alert-light">
            <i class="fas fa-circle-notch fa-spin"></i> Lade Inhalte...
        </p>
    {:then data}
        <h2 class="mb-4">{@html data[0].mname}</h2>

        {#await childItems}
            <p class="alert alert-light">
                <i class="fas fa-circle-notch fa-spin"></i> Untermenü Elemente werden geladen...
            </p>
        {:then subitems}
            {#if subitems.length > 0}
                <div class="card mb-4 bg-light shadow border-0">
                    <div class="card-body pt-3">
                        <h6 class="card-subtitle mb-3 text-muted d-inline me-2">Zugeordnete Menüpunkte:</h6>
                        {#each subitems as subitem}
                            <a href="/menu-item/{subitem.mid}" class="btn btn-link text-decoration-none me-0" role="button">
                                <i class="far fa-sticky-note"></i> {@html subitem.mname}
                            </a>
                        {/each}
                    </div>
                </div>
            {/if}
        {:catch error}
            <p style="color: red">{error.message}</p>
        {/await}

        <div class="row">
            <div class="col-6">
                <div class="dropdown">
                    <button class="btn btn-primary w-100 mb-3" type="button" id="dropdownNewContent" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-plus"></i> Neuer Inhalt
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownNewContent">
                        <li><button class="dropdown-item" on:click={() => { navigate("/create-content/"+data[0].mid, { replace: false }) }}><i class="fas fa-heading me-1"></i> Neuer Textinhalt</button></li>
                        <li><button class="dropdown-item" on:click={() => { navigate("/create-form-content/"+data[0].mid, { replace: false }) }}><i class="fas fa-comments me-1"></i> Neues Formular</button></li>
                        <li><button class="dropdown-item" on:click={() => { navigate("/create-map-content/"+data[0].mid, { replace: false }) }}><i class="fas fa-map me-1"></i> Neue Karte</button></li>
                    </ul>
                </div>
            </div>
            <div class="col-6">
                <button on:click={ () => openMenuItemSettings(
                    {
                        'view': data[0].mview,
                        'sort': data[0].msort,
                        'detail_view_settings': data[0].mdetail_view_settings,
                        'placement_non_pinned': data[0].mplacement_non_pinned
                    }
                ) } class="btn btn-primary w-100 mb-3"><i class="fas fa-cog"></i> Einstellungen</button>
            </div>
        </div>
        <ComponentItemsList {model_root} {application_root} mid="{id}" sort_by="{data[0].msort}" />

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}
</div>
